import React from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import momentPlugin from '@fullcalendar/moment';
import frLocale from '@fullcalendar/core/locales/fr';
import 'moment/locale/fr';
import './CustomCalendar.css'

const CustomCalendar = ({ 
  events, 
  onDateClick, 
  onEventClick, 
  onBookingCoachClick,
  initialView = 'dayGridMonth',
  height = 'auto',
  onBookingClick
}) => {
  // Fonction pour déterminer si un événement est passé
  const isEventPast = (event) => {
    const dateBooking = event.extendedProps?.date_booking;
    const heureDeb = event.extendedProps?.heure_deb;
    
    if (!dateBooking || !heureDeb) return false;
    
    const eventDateTime = new Date(dateBooking + 'T' + heureDeb);
    const now = new Date();
    return now > eventDateTime;
  };

  // Gestion du clic sur les événements
  const handleEventClick = (clickInfo) => {
    const isPast = isEventPast(clickInfo.event);
    
    // MODIFICATION : Permettre le clic même pour les événements passés
    // (la logique de restriction sera gérée dans le composant parent)
    if (onEventClick) {
      onEventClick(clickInfo);
    }
  };

  const handleButtonClick = (e, eventInfo) => {
    e.stopPropagation(); // Empêche la propagation du clic
    
    const isPastBooking = isEventPast(eventInfo.event);
    
    // MODIFICATION : Permettre le clic même pour les événements passés
    // (la logique de restriction sera gérée dans le composant parent)
    
    // Appeler la nouvelle fonction pour ouvrir le modal de booking
    if (onBookingClick) {
      onBookingClick(eventInfo);
    }
    
    // Garder l'ancien comportement aussi si nécessaire
    if (onEventClick) {
      onEventClick(eventInfo);
    }
  };

  // Nouvelle fonction pour le contenu personnalisé avec gestion de clic
  const renderEventContent = (eventInfo) => {
    const heureDeb = eventInfo.event.extendedProps?.heure_deb || '';
    const typeBooking = eventInfo.event.extendedProps?.type_booking || '';
    const nbParticipants = eventInfo.event.extendedProps?.nb_participants || 0;
    const isPastBooking = isEventPast(eventInfo.event);

    return (
      <div className="custom-event-wrapper">
        <button 
          className={`custom-event-content ${isPastBooking ? 'past-booking' : ''}`}
          style={{ 
            color: 'white', 
            fontWeight: 600, 
            padding: '2px 4px', 
            fontSize: '0.75rem',
            width: '100%',
            border: 'none',
            background: 'transparent',
            cursor: 'pointer', // TOUJOURS pointer pour permettre le clic
            textAlign: 'left'
          }}
          onClick={(e) => handleButtonClick(e, eventInfo)}
          // SUPPRIMER le disabled pour permettre le clic même pour les événements passés
        >
          <div className="event-time" style={{ fontWeight: 'bold', marginBottom: '2px' }}>
            {heureDeb} - {typeBooking}
          </div>
          <div className="event-participants" style={{ fontSize: '0.7rem' }}>
            {nbParticipants} places disponibles
          </div>
          {isPastBooking && (
            <div style={{ fontSize: '0.6rem', fontStyle: 'italic' }}>
              (Cet événement est passé)
            </div>
          )}
        </button>
      </div>
    );
  };

  // Préparer les événements avec les bonnes couleurs et classes
  const preparedEvents = events.map(event => {
    const isPast = isEventPast(event);
    
    return {
      ...event,
      className: isPast ? 'past-event' : '', // Supprimer 'disabled-event'
      color: isPast ? '#bababbff' : event.color,
      textColor: isPast ? '#ffffff' : '#ffffff'
    };
  });

  return (
    <FullCalendar
      plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, momentPlugin]}
      initialView={initialView}
      locale={frLocale}
      headerToolbar={{
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay'
      }}
      height={height}
      events={preparedEvents}
      dateClick={onDateClick}
      eventClick={handleEventClick}
      eventDisplay="block"
      eventContent={renderEventContent}
      eventTimeFormat={{
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }}
      slotMinTime="06:00:00"
      slotMaxTime="22:00:00"
      allDaySlot={false}
      nowIndicator={true}
      editable={false}
      selectable={true}
      dayMaxEvents={3}
    />
  );
};

export default CustomCalendar;